import DOMPurify from 'dompurify';

const TOOLTIP_ALLOWED_TAGS = ['table', 'tbody', 'thead', 'tr', 'td', 'th', 'strong', 'span', 'br'];
const TOOLTIP_ALLOWED_ATTR = ['class', 'colspan'];

/**
 * Sanitize HTML rendered into chart/report tooltips.
 * Preserves table layout used across chart components.
 */
export function sanitizeTooltipHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS: TOOLTIP_ALLOWED_TAGS,
    ALLOWED_ATTR: TOOLTIP_ALLOWED_ATTR,
  });
}

/**
 * Escape plain text for safe insertion into HTML template strings.
 */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Only allow same-origin relative redirects (mirrors Login.tsx rules).
 */
export function safeRedirectPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw || typeof raw !== 'string') return fallback;
  const trimmed = raw.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return fallback;
  if (trimmed.includes('\\') || trimmed.toLowerCase().startsWith('javascript:')) return fallback;
  return trimmed;
}
